import { APP_NAME } from '@js/constants'

const routes = [
  {
    path: '/auth',
    component: () => import('@components/auth/auth-root-view'),
    children: [
      {
        path: 'verification/email/:context',
        name: 'email-verification',
        component: () => import('@components/auth/email-verification-view'),
        meta: {
          title: 'Verify Email',
          requireAuth: false,
          requireTenant: false,
        },
      },
      {
        path: 'verification/email/login',
        name: 'login',
        redirect: {
          name: 'email-verification',
          params: { context: 'login', },
        },
      },
      {
        path: 'verification/email/password-reset',
        name: 'password-reset',
        redirect: {
          name: 'email-verification',
          params: { context: 'password-reset', },
        },
      },
      {
        path: 'verification/email/signup',
        name: 'signup',
        redirect: {
          name: 'email-verification',
          params: { context: 'signup', },
        },
      },
      {
        path: 'verification/email',
        redirect: { name: 'signup' },
      },
      {
        path: '',
        component: () => import('@components/auth/auth-view'),
        children: [
          {
            path: 'expired-link',
            name: 'expired-link',
            component: () => import('@components/auth/expired-link-view'),
            meta: {
              title: `Link Expired - ${APP_NAME}`,
              requireAuth: false,
              requireTenant: false,
            },
          },
          {
            path: 'login',
            name: 'login-continue',
            component: () => import('@components/auth/login-view'),
            meta: {
              title: 'Login',
              requireAuth: false,
              requireTenant: false,
            },
          },
          {
            path: 'reset/password',
            name: 'password-reset-continue',
            component: () => import('@components/auth/password-reset-view'),
            meta: {
              title: 'Password Reset',
              requireAuth: false,
              requireTenant: false,
            },
          },
          {
            path: 'signup',
            name: 'signup-continue',
            component: () => import('@components/auth/signup-view'),
            meta: {
              title: 'Signup',
              requireAuth: false,
              requireTenant: false,
            },
          },
          {
            path: 'sso/callback',
            name: 'sso-callback',
            component: () => import('@components/auth/sso-callback-view'),
            meta: {
              title: 'Single Sign-On',
              requireAuth: false,
              requireTenant: false,
            },
          },
          {
            path: 'sso/redirect',
            name: 'sso-redirect',
            component: () => import('@components/auth/sso-redirect-view'),
            meta: {
              title: 'SSO Redirecting',
              requireAuth: false,
              requireTenant: false,
            },
          },
        ],
      },
    ],
  },
];

export default routes;
